import jwt_decode from 'jwt-decode'
import store from '@/store'

const removeDataTableStates = () => Object.keys(sessionStorage)
                                        .filter(k => /^dt-state/.test(k))
                                        .forEach(k => sessionStorage.removeItem(k))

export default [
    {
        path: '/',
        name: 'index',
        component: () => import(/* webpackChunkName: "" */ '../views/Index.vue'),
        children: [
            {
                path: '',
                name: 'index',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../components/Public/Index.vue')
            },
            {
                path: 'acerca-de-startup',
                name: 'informacion-miniempresas',
                component: () => import(/* webpackChunkName: "Information" */ '../views/Public/information.vue')
            },
            {
                path: 'faq',
                name: 'FAQ',
                component: () => import(/* webpackChunkName: "FAQ" */ '../views/Public/FAQ.vue')
            },
            // {
            //     path: 'modalidades',
            //     name: 'modalities',
            //     component: () => import(/* webpackChunkName: "Modalities" */ '../views/Public/Modalities.vue')
            // },
            {
                path: 'premios',
                name: 'ecosistema',
                component: () => import(/* webpackChunkName: "Ecosistema" */ '../views/Public/Ecosistema.vue')
            },
            {
                path: 'inscripciones',
                name: 'inscriptions',
                component: () => import(/* webpackChunkName: "Inscriptions" */ '../views/Public/inscriptions.vue')
            },
            {
                path: 'registro-jefe-proyecto',
                name: 'register-teacher',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/CodeTeacher.vue')
            },
            {
                path: 'registro-jefe-proyecto-datos/:centerCode',
                name: 'register-teacher-data',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/FormTeacher.vue')
            },
            {
                path: 'registro-integrante',
                name: 'register-student',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/CodeStudent.vue')
            },
            {
                path: 'registro-integrante-datos/:centerCode',
                name: 'register-student-data',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/FormStudent.vue')
            },
            {
                path: 'registro-mentor',
                name: 'register-mentor',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/CodeCompany.vue')
            },
            {
                path: 'registro-mentor-datos/:companyCode',
                name: 'register-mentor-data',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/FormCompany.vue')
            },
            {
                path: 'registro-tutor',
                name: 'register-tutor',
                component: () => import(/* webpackChunkName: "RegisterTutorCode" */ '../views/Public/CodeTutor.vue')
            },
            {
                path: 'registro-tutor-datos/:ministerialCode',
                name: 'register-tutor-data',
                component: () => import(/* webpackChunkName: "RegisterTutor" */ '../views/Public/FormTutor.vue')
            },
            {
                path: 'gracias/:role?/:id?',
                name: 'thanks',
                component: () => import(/* webpackChunkName: "RegisterTeacher" */ '../views/Public/Thanks.vue')
            },
            {
                path: 'login',
                name: 'login',
                component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
            },
            {
                path: 'olvido-contrasena',
                name: 'forgot-password',
                component: () => import(/* webpackChunkName: "Login" */ '../views/ForgotPassword.vue')
            },
            {
                path: 'resetear-contrasena/:id_user/:token_reset',
                name: 'reset-password',
                component: () => import(/* webpackChunkName: "Login" */ '../views/ResetPassword.vue')
            }
        ]
    },
    {
        path: '/home',
        name: 'home',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
        beforeEnter: async (to, from, next) => {
            try {
                jwt_decode(store.state.auth.token);
                return next()
            } catch(e) {
                store.commit('auth/logout', null, { root: true })
                return next('/login')
            }
        },
        children: [
            {
                path: '',
                name: 'dashboard',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue')
            },
            {
                path: '/calendario',
                name: 'calendar',
                component: () => import(/* webpackChunkName: "Calendar" */ '../views/Private/Calendar/Calendar.vue')
            },
            {
                path: '/multimedia',
                name: 'multimedia',
                component: () => import(/* webpackChunkName: "Multimedia" */ '../views/Private/Library/Library.vue')
            },
            {
                path: '/project-management',
                name: 'project-management',
                component: () => import(/* webpackChunkName: "ProjectManagement" */ '../views/Private/Library/ProjectManagement.vue')
            },
            {
                path: '/ranking/:id_competition',
                name: 'ranking',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Private/Ranking/Ranking.vue')
            },
            {
                path: '/profesores',
                name: 'teachers',
                component: () => import(/* webpackChunkName: "Teacher" */ '../views/Private/Teachers/Teachers.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'teacher') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/profesores/:id/:id_center?',
                name: 'teacher',
                component: () => import(/* webpackChunkName: "Teacher" */ '../views/Private/Teachers/Teacher.vue'),
                meta: { authorize: ["admin", "profesor"] }
            },
            {
                path: '/tutores',
                name: 'tutors',
                component: () => import(/* webpackChunkName: "Tutors" */ '../views/Private/Tutors/Tutors.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'tutor') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/tutores/:id',
                name: 'tutor',
                component: () => import(/* webpackChunkName: "Tutors" */ '../views/Private/Tutors/Tutor.vue'),
                meta: { authorize: ["admin", "tutor"] }
            },
            {
                path: '/alumnos',
                name: 'students',
                component: () => import(/* webpackChunkName: "Students" */ '../views/Private/Students/Students.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'student') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/alumnos-sin-validar',
                name: 'students-no-validate',
                component: () => import(/* webpackChunkName: "StudentsNoValidate" */ '../views/Private/Students/StudentsNoValidate.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/alumnos/:id/:id_center?/:id_class?',
                name: 'student',
                component: () => import(/* webpackChunkName: "Centers" */ '../views/Private/Students/Student.vue'),
                meta: { authorize: ["admin", "alumno"] }
            },
            {
                path: '/guia-instrucciones',
                name: 'guideInstructions',
                component: () => import(/* webpackChunkName: "guideInstructions" */ '../views/Private/Instructions/Guide.vue'),
            },
            // {
            //     path: '/clases',
            //     name: 'classes',
            //     component: () => import(/* webpackChunkName: "Classes" */ '../views/Private/Classes/Classes.vue'),
            //     beforeEnter: (to, from, next) => {
            //         if (from.name !== 'class') removeDataTableStates()
            //         return next()
            //     },
            //     meta: { authorize: ["admin", "profesor"] }
            // },
            // {
            //     path: '/clases/:id/:id_center?/:id_teacher?',
            //     name: 'class',
            //     component: () => import(/* webpackChunkName: "Class" */ '../views/Private/Classes/Class.vue'),
            //     meta: { authorize: ["admin", "profesor"] }
            // },
            {
                path: '/centros',
                name: 'centers',
                component: () => import(/* webpackChunkName: "Centers" */ '../views/Private/Centers/Centers.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'centros') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/centros/:id',
                name: 'center',
                component: () => import(/* webpackChunkName: "Center" */ '../views/Private/Centers/Center.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/empresas',
                name: 'companies',
                component: () => import(/* webpackChunkName: "Companies" */ '../views/Private/Companies/Companies.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'company') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/empresas/:id',
                name: 'company',
                component: () => import(/* webpackChunkName: "Company" */ '../views/Private/Companies/Company.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/voluntarios',
                name: 'voluntaries',
                component: () => import(/* webpackChunkName: "Voluntaries" */ '../views/Private/Voluntaries/Voluntaries.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'voluntary') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/voluntarios/:id/:id_company?',
                name: 'voluntary',
                component: () => import(/* webpackChunkName: "Voluntary" */ '../views/Private/Voluntaries/Voluntary.vue'),
                meta: { authorize: ["admin", "mentor", "jurado", "mentor/jurado"] }
            },
            {
                path: '/grupos-trabajo',
                name: 'team-groups',
                component: () => import(/* webpackChunkName: "TeamGroups" */ '../views/Private/TeamGroups/TeamGroups.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'team-group') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin", "mentor", "profesor", "mentor/jurado", "tutor"] }
            },
            {
                path: '/grupos-trabajo/:id/:id_center?/:id_class?',
                name: 'team-group',
                component: () => import(/* webpackChunkName: "TeamGroup" */ '../views/Private/TeamGroups/TeamGroup.vue'),
                meta: { authorize: ["admin", "mentor", "profesor", "alumno", "mentor/jurado", "tutor"] },
            },
            {
                path: '/mi-nube-grupo',
                name: 'cloudgroup',
                component: () => import(/* webpackChunkName: "CloudGroup" */ '../views/Private/CloudGroup/CloudGroup.vue'),
                meta: { authorize: ["alumno"] }
            },
            {
                path: '/conversacion-grupo/:id/:go_tab?',
                name: 'conversation-group',
                component: () => import(/* webpackChunkName: "Conversations" */ '../views/Private/CloudGroup/Conversation.vue'),
                meta: { authorize: ["admin", "mentor", "profesor", "alumno", "mentor/jurado", "tutor"] }
            },
            {
                path: '/competiciones',
                name: 'competitions',
                component: () => import(/* webpackChunkName: "Competition" */ '../views/Private/Competition/Competitions.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'competition') removeDataTableStates()
                    return next()
                }
            },
            {
                path: '/competiciones-abiertas/:go?',
                name: 'open-competitions',
                component: () => import(/* webpackChunkName: "Competition" */ '../views/Private/Competition/Index.vue'),
            },
            {
                path: '/competiciones/:id',
                name: 'competition',
                component: () => import(/* webpackChunkName: "Competition" */ '../views/Private/Competition/Competition.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/mi-competicion/:id_assignment?/:id_competition?/:id_group_team?',
                name: 'my-competition',
                component: () => import(/* webpackChunkName: "MyCompetition" */ '../views/Private/Competition/MyCompetition.vue')
            },
            {
                path: '/competicion-grupos',
                name: 'competition-groups',
                component: () => import(/* webpackChunkName: "CompetitionGroups" */ '../views/Private/Competition/CompetitionGroups.vue'),
                beforeEnter: (to, from, next) => {
                    removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/matching',
                name: 'matching',
                component: () => import(/* webpackChunkName: "CompetitionGroups" */ '../views/Private/Matching/Matching.vue'),
                meta: { authorize: ["admin", "mentor", "mentor/jurado"] }
            },
            {
                path: '/matching-tutores',
                name: 'matching-tutors',
                component: () => import(/* webpackChunkName: "MatchingTutors" */ '../views/Private/Matching/MatchingTutors.vue'),
                meta: { authorize: ["admin", "tutor"] }
            },
            {
                path: '/mis-evaluaciones',
                name: 'my-evaluations',
                component: () => import(/* webpackChunkName: "MyEvaluations" */ '../views/Private/Competition/MyEvaluations.vue'),
                meta: { authorize: ["admin", "jurado", "mentor/jurado"] }
            },
            {
                path: '/maestros',
                name: 'masters',
                component: () => import(/* webpackChunkName: "Masters" */ '../views/Private/Masters/Masters.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/admin-instrucciones',
                name: 'adminInstructions',
                component: () => import(/* webpackChunkName: "adminInstructions" */ '../views/Private/Instructions/Admin.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/admin-instrucciones/:id_instruction',
                name: 'adminInstruction',
                component: () => import(/* webpackChunkName: "adminInstruction" */ '../views/Private/Instructions/Instruction.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/tipo-centros',
                name: 'type_centers',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Private/Masters/Type_Centers/Type_Centers.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/tipo-centro/:id?',
                name: 'type_center',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Private/Masters/Type_Centers/Type_Center.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/naturalidades-centros',
                name: 'naturalities_centers',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Private/Masters/Naturality_Centers/Naturalities_Centers.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/naturalidad-centro/:id?',
                name: 'naturality_center',
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Private/Masters/Naturality_Centers/Naturality_Center.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/tematicas',
                name: 'Themes',
                component: () => import(/* webpackChunkName: "Themes" */ '../views/Private/Masters/Themes/Themes.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/tematica/:id?',
                name: 'Theme',
                component: () => import(/* webpackChunkName: "Theme" */ '../views/Private/Masters/Themes/Theme.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/usuarios',
                name: 'users',
                component: () => import(/* webpackChunkName: "Users" */ '../views/Private/Users/Users.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/usuarios/:id',
                name: 'user',
                component: () => import(/* webpackChunkName: "Users" */ '../views/Private/Users/User.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/lista-bloqueo-matching',
                name: 'list-block-matching',
                component: () => import(/* webpackChunkName: "ListBlockMatching" */ '../views/Private/Matching/ListBlockMatching.vue'),
                meta: { authorize: ["admin"] }
            },
            {
                path: '/bloqueo-matching',
                name: 'block-matching',
                component: () => import(/* webpackChunkName: "BlockMatching" */ '../views/Private/Matching/BlockMatching.vue'),
                beforeEnter: (to, from, next) => {
                    removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin"] }
            },
            {
                path: '/administrar-conversaciones',
                name: 'AdminConversations',
                component: () => import(/* webpackChunkName: "AdminConversations" */ '../views/Private/Conversations/Admin/Conversations.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name != 'AdminConversation') sessionStorage.removeItem('filterConversation')
                    removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin", "mentor", "jurado", "mentor/jurado"] }
            },
            {
                path: '/administrar-conversaciones/:id',
                name: 'AdminConversation',
                component: () => import(/* webpackChunkName: "AdminConversation" */ '../views/Private/Conversations/Admin/Conversation.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name === 'AdminConversations') {
                        sessionStorage.removeItem('filter-active')
                        removeDataTableStates()
                    }
                    if (from.name !== 'ManagementConversation') removeDataTableStates()
                    return next()
                },
                meta: { authorize: ["admin", "mentor", "jurado", "mentor/jurado"] }
            },
            {
                path: '/administrar-conversaciones/:id_thread/management/:from?',
                name: 'ManagementConversation',
                component: () => import(/* webpackChunkName: "ManagementConversation" */ '../views/Private/Conversations/Admin/Management.vue')
            },
            {
                path: '/conversaciones',
                name: 'conversations',
                component: () => import(/* webpackChunkName: "AdminConversation" */ '../views/Private/Conversations/Public/Index.vue')
            },
            {
                path: '/conversaciones/:id',
                name: 'conversation',
                component: () => import(/* webpackChunkName: "AdminConversation" */ '../views/Private/Conversations/Public/Conversation.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name === 'conversations') sessionStorage.removeItem('tabActive')
                    return next()
                }
            },
            {
                path: '/notificaciones',
                name: 'notifications',
                component: () => import(/* webpackChunkName: "Notifications" */ '../views/Private/Notifications/Notifications.vue'),
                beforeEnter: (to, from, next) => {
                    removeDataTableStates()
                    return next()
                }
            },
            {
                path: '/notificaciones/:id_notification',
                name: 'notification',
                component: () => import(/* webpackChunkName: "Notification" */ '../views/Private/Notifications/Notification.vue')
            },
            {
                path: '/notificaciones/visor/:id_notification/:from',
                name: 'visor-notification',
                component: () => import(/* webpackChunkName: "VisorNotification" */ '../views/Private/Notifications/Visor.vue')
            },
            {
                path: '/mis-notificaciones',
                name: 'my-notifications',
                component: () => import(/* webpackChunkName: "MyNotifications" */ '../views/Private/Notifications/MyNotifications.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'visor-notification') sessionStorage.removeItem('notification-filter-active')
                    removeDataTableStates()
                    return next()
                }
            },
            {
                path: '/revisar-feedback/:id_competition/:id_group_team',
                name: 'checkFeedback',
                component: () => import(/* webpackChunkName: "checkFeedback" */ '../views/Private/Feedback/Check.vue'),
                meta: { authorize: ["admin", "profesor", "alumno", "tutor"] }
            },
        ]
    },
    { path: "/:pathMatch(.*)*", redirect: '/' }
]